var forecastObservers = [];

function disconnectForecastObservers() {
  forecastObservers.forEach(function (observer) {
    observer.disconnect();
  });
  forecastObservers = [];
}

function keepNaturalHeight(element) {
  var observer = new MutationObserver(function () {
    if (element.style.height) {
      element.style.removeProperty('height');
    }
    if (element.style.minHeight) {
      element.style.removeProperty('min-height');
    }
  });

  observer.observe(element, {
    attributes: true,
    attributeFilter: ['style']
  });
  forecastObservers.push(observer);
}

document.addEventListener('turbolinks:before-cache', disconnectForecastObservers);

document.addEventListener('turbolinks:load', function () {
  disconnectForecastObservers();
  var $ = window.jQuery || window.$;

  var dailyForecastTable = document.getElementById('daily-forecast-table');
  if (dailyForecastTable) {
    keepNaturalHeight(dailyForecastTable);
  }

  var dailyForecastList = document.getElementById('daily-forecast-list');
  if (dailyForecastList) {
    keepNaturalHeight(dailyForecastList);
  }

  if (!$) {
    return;
  }

  $(document)
    .off('click.hourlyDetails', '.hourly-row-toggle')
    .on('click.hourlyDetails', '.hourly-row-toggle', function (event) {
      event.preventDefault();

      var $button = $(this);
      var targetSelector = $button.attr('data-hourly-target');
      if (!targetSelector) {
        return;
      }

      var $target = $(targetSelector);
      if (!$target.length) {
        return;
      }

      var shouldOpen = !$target.hasClass('show');
      $target.toggleClass('show', shouldOpen);
      $button.toggleClass('collapsed', !shouldOpen);
      $button.attr('aria-expanded', shouldOpen ? 'true' : 'false');
    });

  $(document)
    .off('click.hourlyMore', '.hourly-show-more')
    .on('click.hourlyMore', '.hourly-show-more', function (event) {
      event.preventDefault();

      var $button = $(this);
      var targetSelector = $button.attr('data-hourly-more-target');
      if (!targetSelector) {
        return;
      }

      var $target = $(targetSelector);
      if (!$target.length) {
        return;
      }

      var shouldOpen = !$target.hasClass('show');
      $target.toggleClass('show', shouldOpen);
      $button.toggleClass('is-open', shouldOpen);
      $button.attr('aria-expanded', shouldOpen ? 'true' : 'false');
    });
});
